import {LineupPlayer, LineupPlayerEvent, MatchLineups, TimelineUpdate} from '../../../utils/types';

/**
 * Derive a new player events from the involved updates
 */
const deriveLineupPlayerEvents = (events: LineupPlayerEvent[], involvedUpdates: TimelineUpdate[]): LineupPlayerEvent[] => {
  return involvedUpdates.map((update) => {
    const sameTypeEvent = events.find((event) => event.type === update.type);
    if (sameTypeEvent) {
      return {
        ...sameTypeEvent,
        count: sameTypeEvent.count + 1,
      };
    }

    return {
      type: update.type,
      count: 1,
    };
  });
};

/**
 * Creates a function updating a lineup player object according to the received updates.
 */
const updateInvolvedPlayerByEvents = (updates: TimelineUpdate[]) => (lineupPlayer: LineupPlayer): LineupPlayer => {
  // the updates involving the current player
  const involvedUpdates = updates.filter(({playerIds}) => playerIds.includes(lineupPlayer.sportRadarPlayerId));
  if (involvedUpdates.length === 0) return lineupPlayer;

  return {
    ...lineupPlayer,
    events: deriveLineupPlayerEvents(lineupPlayer.events, involvedUpdates),
  };
};

/**
 * Derives a new updated version of the passed lineups object according to the received updates.
 */
const deriveLineupsFromUpdates = (updates: TimelineUpdate[], lineups?: MatchLineups): MatchLineups | undefined => {
  if (!lineups || updates.length === 0) return undefined;

  return {
    away: {
      teamName: lineups.away.teamName,
      main: lineups.away.main.map(updateInvolvedPlayerByEvents(updates)),
      bench: lineups.away.bench.map(updateInvolvedPlayerByEvents(updates)),
    },
    home: {
      teamName: lineups.home.teamName,
      main: lineups.home.main.map(updateInvolvedPlayerByEvents(updates)),
      bench: lineups.home.bench.map(updateInvolvedPlayerByEvents(updates)),
    },
  };
};

export default deriveLineupsFromUpdates;
